import { FC } from 'react';
import { DagStatus } from '@agilelab/plugin-wb-builder-common';
import { Chip, createStyles, makeStyles, Typography } from '@material-ui/core';
import { DetailIcon } from '../DetailIcon';

interface Props {
  description: string;
  componentName?: string;
  status: DagStatus;
}

const useStyles = makeStyles(() =>
  createStyles({
    componentId: {
      flex: 1,
    },
    chip: {
      margin: 0,
    },
  }),
);

export const ComponentItem: FC<Props> = ({
  description,
  status,
  componentName,
}) => {
  const classes = useStyles();

  return (
    <>
      <DetailIcon status={status} filled />
      <div className={classes.componentId}>
        <Typography>
          <strong>{description}</strong>
        </Typography>
        {!!componentName && (
          <Typography color="primary">{componentName}</Typography>
        )}
      </div>
      <Chip
        label="Technology Adapter"
        className={classes.chip}
        color="primary"
      />
    </>
  );
};
